export var SPACING_UNIT_PX = 4;
export var ROOT_FONT_SIZE_PIXELS = 16;
export var SPACING_UNIT_REM = 0.5;